// Normalize any API error (FastAPI string detail, Pydantic 422 array, network) into a readable string.
export const parseApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => {
      const field = Array.isArray(x?.loc) ? x.loc[x.loc.length - 1] : "";
      return x?.msg ? (field ? `${field}: ${x.msg}` : x.msg) : "";
    }).filter(Boolean);
    if (msgs.length) return msgs.join(" · ");
  }
  if (d && typeof d === "object" && d.msg) return d.msg;
  return err?.message || fallback;
};
